module.exports = __webpack_public_path__ + "img/0-02-0a-37f2ef67f6c73cfabd7275b5a22d5f19e881eb9bd2e1c1a0d555224a7473bd3a_5f24a97f.d2267681.jpg";